var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClousureTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10H5V22H1V10ZM21 13L18 20H9V10L13.34 5.65997L12.23 11H21V13ZM21 9H14.69L15.64 4.42999L15.67 4.10999C15.67 3.69999 15.5 3.31999 15.23 3.04999L14.17 2L7.59 8.59C7.22 8.95 7 9.45 7 10V20C7 21.1 7.9 22 9 22H18C18.83 22 19.54 21.5 19.84 20.78L22.86 13.73C22.95 13.5 23 13.26 23 13V11C23 9.9 22.1 9 21 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10H5V22H1V10ZM21 13L18 20H9V10L13.34 5.65997L12.23 11H21V13ZM21 9H14.69L15.64 4.42999L15.67 4.10999C15.67 3.69999 15.5 3.31999 15.23 3.04999L14.17 2L7.59 8.59C7.22 8.95 7 9.45 7 10V20C7 21.1 7.9 22 9 22H18C18.83 22 19.54 21.5 19.84 20.78L22.86 13.73C22.95 13.5 23 13.26 23 13V11C23 9.9 22.1 9 21 9Z",
    fill: "#8285F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClousureTask);
export default __webpack_public_path__ + "static/media/clousure-task.7d29ead28b53e6e5d386ec5cec6a3660.svg";
export { ForwardRef as ReactComponent };